import React from "react";
import { FaBullseye, FaEye, FaHandshake } from "react-icons/fa";
import "../../styles/VMC.css";

function VMC() {
    return (
        <section className="section bg-c-light border-top vmc-section">
            <div className="container">
                <div className="row">

                    {/* Section Header */}
                    <div className="col-md-12 mb-5 text-center">
                        <h1 className="main-header">Vision, Mission & Values</h1>
                        <div className="underline mx-auto"></div>
                    </div>

                    {/* Vision */}
                    <div className="col-md-4 text-center">
                        <FaEye size={48} color="indigo" className="mb-3" />
                        <h2 className="fw-bold mb-2">Our Vision</h2>
                        <p className="text-muted">
                            To become a leading and trusted multi-service provider recognized for customer satisfaction, service excellence,
                            and ethical business practices, empowering communities with dependable insurance coverage, advanced technology,
                            and sustainable energy solutions.
                        </p>
                    </div>

                    {/* Mission */}
                    <div className="col-md-4 text-center">
                        <FaBullseye size={48} color="blue" className="mb-3" />
                        <h2 className="fw-bold mb-2">Our Mission</h2>
                        <p className="text-muted">
                            To provide reliable insurance, technology, security, and energy solutions under one roof by delivering honest guidance,
                            quality products, and prompt customer support. Our mission is to simplify services for individuals
                            and businesses while building long-term trust through transparency and professionalism.
                        </p>
                    </div>

                    {/* Core Values */}
                    <div className="col-md-4 text-center vmc-core-values">
                        <FaHandshake size={48} color="green" className="mb-3" />
                        <h2 className="fw-bold mb-3">Our Core Values</h2>

                        <ul className="vmc-core-values">
                            <li>Trust & Integrity</li>
                            <li>Customer First</li>
                            <li>Quality & Reliability</li>
                            <li>Fast & Responsive Support</li>
                            <li>Innovation & Growth</li>
                            <li>Long-Term Relationships</li>
                        </ul>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default VMC;
